import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const ShipmentStatusWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
}));

export const ShipmentStatusTitle = styled("span")(() => ({
  color: colors.warning600,
  borderRadius: 20,
  height: "28px",
  fontSize: "12px",
  padding: "8px 12px",
  letterSpacing: "0.5px",
  background: colors.warning50,
  fontWeight: 600,
  fontFamily: "Manrope",
}));
